export const PHONE_COUNTRIES = [
  { code: "FR", name: "France", dial: "33" },
  { code: "BE", name: "Belgique", dial: "32" },
  { code: "CH", name: "Suisse", dial: "41" },
  { code: "LU", name: "Luxembourg", dial: "352" },
  { code: "MC", name: "Monaco", dial: "377" },
  { code: "CA", name: "Canada", dial: "1" },
  { code: "DE", name: "Allemagne", dial: "49" },
  { code: "ES", name: "Espagne", dial: "34" },
  { code: "IT", name: "Italie", dial: "39" },
  { code: "PT", name: "Portugal", dial: "351" },
  { code: "GB", name: "Royaume-Uni", dial: "44" },
  { code: "IE", name: "Irlande", dial: "353" },
  { code: "NL", name: "Pays-Bas", dial: "31" },
  { code: "AT", name: "Autriche", dial: "43" },
  { code: "PL", name: "Pologne", dial: "48" },
  { code: "GR", name: "Grèce", dial: "30" },
  { code: "SE", name: "Suède", dial: "46" },
  { code: "DK", name: "Danemark", dial: "45" },
  { code: "NO", name: "Norvège", dial: "47" },
  { code: "US", name: "États-Unis", dial: "1" },
  { code: "MA", name: "Maroc", dial: "212" },
  { code: "DZ", name: "Algérie", dial: "213" },
  { code: "TN", name: "Tunisie", dial: "216" },
  { code: "SN", name: "Sénégal", dial: "221" },
  { code: "CI", name: "Côte d'Ivoire", dial: "225" },
  { code: "CM", name: "Cameroun", dial: "237" },
  { code: "MG", name: "Madagascar", dial: "261" },
  { code: "RE", name: "La Réunion", dial: "262" },
  { code: "GP", name: "Guadeloupe", dial: "590" },
  { code: "MQ", name: "Martinique", dial: "596" },
  { code: "GF", name: "Guyane", dial: "594" },
  { code: "PF", name: "Polynésie française", dial: "689" },
  { code: "NC", name: "Nouvelle-Calédonie", dial: "687" },
  { code: "IL", name: "Israël", dial: "972" },
  { code: "AE", name: "Émirats arabes unis", dial: "971" },
  { code: "BR", name: "Brésil", dial: "55" },
];

export const flagUrl = (code) => `https://flagcdn.com/w40/${code.toLowerCase()}.png`;

// Retourne le numéro au format international (+33612345678) ou null si invalide.
export function toE164(raw, country) {
  const s = (raw || "").trim();
  let digits = s.replace(/\D/g, "");
  let full;
  if (s.startsWith("+")) full = "+" + digits;
  else if (digits.startsWith("00")) full = "+" + digits.slice(2);
  else full = "+" + country.dial + digits.replace(/^0+/, "");
  if (!/^\+[1-9]\d{7,14}$/.test(full)) return null;
  if (full.startsWith("+33") && !/^\+33[67]\d{8}$/.test(full)) return null;
  return full;
}
